import React from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Card, Col, Icon, Popconfirm, Row, Table, Input, message } from 'antd';

import debounce from 'debounce'

import { deleteBrand } from './actions';
import { _getSearchBrands } from "../../services"

import AddBrandButton from './add-brand-button';
import EditBrandButton from './edit-brand-button';

class BrandTable extends React.Component{

	render(){

		const { selectedRowKeys } = this.state;


		return (
			<Card 
				title={this.renderSearchInput()}
				extra ={
					<Row type="flex" gutter={8}>
						<Col>
							<Popconfirm 
								placement="bottomLeft" 
								title="Are you sure you want to delete? This action is can't be reversed" 
								onConfirm={this.handleConfirmDelete} 
								okText="Delete" cancelText="Don't Delete">

								<Button
									type="danger" 
									disabled={selectedRowKeys.length === 0}>
									<Icon type="delete" />
									Delete
								</Button>
							
							</Popconfirm>

						</Col>

						<Col>
							<AddBrandButton />
						</Col>
					</Row>
				}>

				{this.renderTable()}

			</Card>
		)
	}

	renderSearchInput = () => {
		return (
			<Input 
				placeholder="Search Here"
				value={this.state.searchParam}
				onChange={( e ) => {
					this.setState({ 
						searchParam: e.target.value.toLowerCase() 
					}, this.handleSearchBrands(e.target.value))
				}}
				/> 
		)


	}

	renderTable = () => {

		const columns = [
			
			{title: '#', key:'index', render: (text, brand, i) => {
				return (
					<p>{i + 1}</p>
				)
			}},
			{title: 'Name', key:'name', dataIndex:'name', render: (text, brand) => {
				return(
					<Row >
						<Col span={1}>
							<Badge status={(brand.featured)? 'success' : 'default'}/>
						</Col>

						<Col span={23}>
							{text}
						</Col>

						
					</Row>
				)
			}},

			{title: 'Logo', key:'logo', render: (text, brand, i) => {

				if(!brand.image){
					return (
						<Row type="flex" justify="start">
							<Col 
							span={15}
							style={{maxHeight: '80px', maxWidth: '80px'}}>
								<p>No Logo</p>	
							</Col>
							
						</Row>
					)
				}

				return (
					<Row type="flex" justify="start">
						<Col 
							span={15}
							style={{maxHeight: '90px', maxWidth: '90px'}}>
							<img alt="brand pic" style={{maxHeight: '90px', maxWidth: "90px"}} 
								src={brand.image.url}/>
						</Col>
					</Row>
				)
			}},

			{title: 'Actions', key: 'actions', render: (brand) => {
				return (
					<div>
						<EditBrandButton 
							brand={brand}
							handleConfirmDelete={this.handleConfirmDelete}
							/>
					</div>
				)
			}}
		]

		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({
					selectedRowKeys
				})
			},

			selectedRowKeys: this.state.selectedRowKeys
		};

		return (
			<Table 
				pagination={{
					defaultPageSize: 1000
				}}
				rowSelection={rowSelection}
				rowKey="_id"
				columns={columns}
				dataSource={this.state.searchResults}
			/>
		)
	}

	constructor(props){
		super(props);

		this.state = {
			brands: [],
			searchParam: "",

			searchResults: [],
			modalIsOpen: false,
			selectedRowKeys: []
		}

		this.handleSearchBrands = debounce(this.handleSearchBrands, 300);
	}
	
	handleConfirmDelete = () => {
		const { selectedRowKeys } = this.state;

		if (selectedRowKeys.length > 1) {
			message.error("Can only delete 1 brand at a time")
			return;
		}

		this.setState({
			selectedRowKeys: []
		})

		// @ken333135 - changed on 200125 to only allow deleting one at a time
		this.props.deleteBrand(selectedRowKeys[0]);
	}

	handleSearchBrands = (value) => {

		if (value === "") {
			this.setState({ 
				searchResults: []
			})
			return
		}
		
		_getSearchBrands(value)
		.then(xhr => {
			this.setState({ 
				searchResults: xhr.data.brands
			})
		})
		.catch(err => {
			console.log(err)
			this.setState({ 
				searchResults: []
			})
		})

	}
}


/**
 * @todo set up actions and reducers to get data from server
 */

export default connect(
	state => ({
		brands: state.brands
	}),

	dispatchEvent => ({
		deleteBrand: (selectedRowKeys) => dispatchEvent( deleteBrand(selectedRowKeys) )
	})
)(BrandTable);


// WEBPACK FOOTER //
// ./src/components/brands/table.js